import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getRelatedPosts, serviceFor } from '../../lib/related';

function RelatedCard({ post }) {
  const service = serviceFor(post);
  return (
    <div className="group flex flex-col" data-testid={`related-card-${post.slug}`}>
      <Link to={`/blog/${post.slug}`} className="block" data-testid={`related-link-${post.slug}`}>
        <div className="relative overflow-hidden rounded-md aspect-[16/9] mb-4 bg-gradient-to-br from-[#00b8ff]/20 to-white/[0.03] border border-white/10">
          {post.image ? (
            <img
              src={post.image}
              alt={post.imageAlt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
          ) : (
            <span className="absolute inset-0 flex items-center justify-center font-display uppercase text-[#f4efe6]/40 text-3xl tracking-tight">
              Pusha Teez
            </span>
          )}
        </div>
        <p className="text-xs uppercase tracking-[0.18em] text-[#00b8ff] mb-2">{post.category}</p>
        <h3 className="font-display text-[#f4efe6] uppercase text-xl md:text-2xl tracking-tight leading-tight group-hover:text-[#00b8ff] transition-colors duration-200">
          {post.title}
        </h3>
      </Link>
      <Link
        to={service.to}
        className="mt-4 inline-flex items-center gap-2 self-start text-sm text-[#cfc8bb] border-b border-white/15 pb-1 hover:text-[#00b8ff] hover:border-[#00b8ff] transition-colors duration-200 group/svc"
        data-testid={`related-service-link-${post.slug}`}
      >
        <span className="text-[11px] uppercase tracking-[0.2em] text-[#7a7a7a]">Service</span>
        {service.label}
        <ArrowRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover/svc:translate-x-1" />
      </Link>
    </div>
  );
}

export default function RelatedReads({ post, allPosts }) {
  const related = getRelatedPosts(post, allPosts);
  if (related.length === 0) return null;
  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-24" data-testid="related-reads">
      <h2 className="font-display text-[#f4efe6] uppercase text-3xl md:text-5xl tracking-tight mb-10">
        Keep <span className="font-script text-[#00b8ff] normal-case italic">reading</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-7 gap-y-12">
        {related.map((rp) => <RelatedCard key={rp.slug} post={rp} />)}
      </div>
    </section>
  );
}
